import create, { SetState } from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject, emptyList } from '@constants/empty';

type RewardEventsStoreType = {
  selectedGoal: boolean;
  setSelectedGoal: (goal: any) => void;
  cityStateMapping: Array<{ state: string; cities: string[] }>;
  setCityStateMapping: (
    mapping: Array<{ state: string; cities: string[] }>
  ) => void;
  selectedCity: string;
  setSelectedCity: (city: string) => void;
};

export const rewardEventsStore = create<RewardEventsStoreType>(
  (set: SetState<RewardEventsStoreType>) => ({
    selectedGoal: emptyObject,
    setSelectedGoal: (goal) =>
      set((state) => ({
        ...state,
        selectedGoal: { ...goal }
      })),
    cityStateMapping: emptyList,
    setCityStateMapping: (mapping) =>
      set((state) => ({
        ...state,
        cityStateMapping: mapping
      })),
    selectedCity: '',
    setSelectedCity: (city) =>
      set((state) => ({
        ...state,
        selectedCity: city
      }))
  })
);

const useRewardEventStore = createHook(rewardEventsStore);

export default useRewardEventStore;
